define('entities/dynamic_text',[
    'app',
    'underscore',
    'backbone',
    'settings',
    'backboneRelational'
], function (
    App,
    _,
    Backbone,
    Settings
) {
  'use strict';

  // Ensure we have a shared model scope for Backbone.Relational
  var app;
  if (Backbone.Relational && Backbone.Relational.store && Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    if (Backbone.Relational && Backbone.Relational.store) {
      Backbone.Relational.store.addModelScope(app.ns);
    }
  }

  // Expose DynamicText in the relational model scope so other models can reference 'DynamicText'
  app.ns.DynamicText = Backbone.RelationalModel.extend({
      relations: [{
          type: Backbone.HasMany,
          key: 'dynamicTextLocalizeds',
          relatedModel: 'DynamicTextLocalized',
          collectionType: 'DynamicTextLocalizedCollection'
      }, {
          type: Backbone.HasOne,
          key: 'refDynamicText',
          relatedModel: 'DynamicText'
      }, {
          type: Backbone.HasOne,
          key: 'refGlossary',
          relatedModel: 'Glossary'
      }],

      idAttribute: 'secId',

      url: function () {
          return Settings.url('compuzz2', 'dynamictexts.json/' + this.get('secId'));
      },

      getCurrentLanguageText: function () {
          var text = this.getTextInLocale(Settings.get('lang'));
          if (!text) {
              text = this.getTextInLocale('en');
          }
          return text;
      },

      setTextInLocale: function (lang, value) {
          this.get('dynamicTextLocalizeds').setTextInLocale(lang, value);
      },

      getTextInLocale: function (lang) {
          if (this.get('refGlossary')) {
              return this.get('refGlossary').get('refDynamicText').getTextInLocale(lang);
          } else {
              var text = this.get('dynamicTextLocalizeds').getTextInLocale(lang);
              if (text !== undefined) {
                  return text;
              } else if (text === undefined && this.get('refDynamicText')) {
                  return this.get('refDynamicText').getTextInLocale(lang);
              } else {
                  return '';
              }
          }
      },

      isUseGlossary: function () {
          if (this.get('refGlossary') && !this.get('readyOnly')) {
              return true;
          } else if (this.get('refDynamicText') && !this.get('refDynamicText').get('readyOnly')) {
              return this.get('refDynamicText').isUseGlossary();
          } else {
              return false;
          }
      },

      isUseParentGlossary: function () {
          if (this.isUseGlossary() && !this.get('refGlossary')) {
              return true;
          } else {
              return false;
          }
      },

      getGlossary: function () {
          return this.get('refGlossary') ? this.get('refGlossary') :
              (this.get('refDynamicText') ? this.get('refDynamicText').getGlossary() : null);
      },

      isOverridden: function (lang) {
          if (this.get('refDynamicText')) {
              return this.get('dynamicTextLocalizeds').isOverridden(lang);
          } else {
              return false;
          }
      },

      revertText: function (lang) {
          this.get('dynamicTextLocalizeds').revertText(lang);
      },

      getTranslationCollection: function () {
          var array = [];

          var langs = Settings.get('currentCAccount').languageSelectionJson.languages;
          _.each(langs, _.bind(function (lang) {
              array.push(new Backbone.Model({
                  lang: lang.locale,
                  value: this.getTextInLocale(lang.locale),
                  dt: this
              }));
          }, this));
          return new Backbone.Collection(array);
      }
  });

  App.reqres.setHandler('dynamic-text:model', function (data) {
      // Use findOrCreate to prevent duplicates in relational store
      if (!data) data = {};
      return app.ns.DynamicText.findOrCreate(data);
  });
});
